import React, { useEffect, useState } from "react";
import { Form, Navbar, Dropdown, InputGroup } from "react-bootstrap";
import "./Header.css";
import {
  faCartShopping,
  faHeadset,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Profile_Offcanvas from "./profile_Offcanvas/Profile_Offcanvas";
import Search_offcanvas from "./search_offcanvas/Search_offcanvas";
import Menu_bar_header from "./menu_bar_header/Menu_bar_header";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { appSetup } from "../../features/master/masterSlice";
import { logout } from "../../features/auth/authSlice";
import { getAllCart } from "../../features/cart/cartSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { encodeId } from "../../utils/common";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const cart = useSelector((state) => state.cart.allCarts);
  const appsetup = useSelector((state) => state.master.app_setup);
  const productdata = useSelector((state) => state.product.allProducts);

  useEffect(() => {
    dispatch(getAllCart());
    dispatch(appSetup());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchTerm,
      }),
    );
  }, [searchTerm, dispatch]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowDropdown(true);
  };

  const handleSelectSuggestion = (id) => {
    navigate(`/product-details-page/${encodeId(id)}`);
    setShowDropdown(false);
    setSearchTerm("");
  };

  const handleLogout = async () => {
    const res = await dispatch(logout({ navigate }));
    if (res.meta?.requestStatus === "fulfilled") {
      setShow(false);
      navigate("/");
    }
  };

  return (
    <>
      <section className="Header">
        {/* TOP BAR */}
        <div className="top_header">
          <div className="custom_container top_header_inner">
            <span>Help Center : +91 6723908110</span>
            <span>
              Akshya Nagar 1st Block 1st Cross, Ramamurthy Nagar, Bangalore -
              560016
            </span>
          </div>
        </div>

        {/* MAIN HEADER */}
        <div className="Header_holder">
          <div className="custom_container">
            <Navbar expand="lg">
              {/* LOGO */}
              <Navbar.Brand href="/home">
                <div className="logo_img_holder">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/Images/Logo/printout_logo.png"
                    }
                    className="logo_img"
                    alt="logo"
                  />
                </div>
              </Navbar.Brand>

              <div className="desktop_header_search_holder">
                <Form className="header_search_holder">
                  {/* CATEGORY */}
                  <select className="category_dropdown">
                    <option>All Categories</option>
                  </select>

                  {/* SEARCH */}
                  <div className="search-dropdown-wrapper">
                    <InputGroup className="searchbar_holder">
                      <Form.Control
                        placeholder="Search By Categories"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </InputGroup>

                    {showDropdown && (
                      <Dropdown className="search-dropdown">
                        <Dropdown.Menu show>
                          {productdata?.map((item, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => handleSelectSuggestion(item?.id)}
                            >
                              {item?.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>

                  {/* SEARCH BUTTON */}
                  <button className="search_btn">Search</button>
                </Form>
              </div>

              {/* SEARCH + ICONS */}
              <div className="header_icon_search_holder">
                {/* SUPPORT */}
                <div className="icon_item">
                  <a href={`tel:${+appsetup?.support_contact_no}`}>
                    <FontAwesomeIcon className="header_icon" icon={faHeadset} />
                  </a>
                </div>

                {/* CART */}
                <div
                  className="icon_item cart_icon_holder"
                  onClick={() => navigate("/order-process")}
                >
                  <div className="header_icon_holder">
                    <FontAwesomeIcon
                      className="header_icon"
                      icon={faCartShopping}
                    />
                    <span className="circle_badge_holder">
                      {cart?.data?.data?.length || 0}
                    </span>
                  </div>
                  <span className="icon_label">My Cart</span>
                </div>

                {/* USER */}
                <div className="icon_item" onClick={() => setShow(true)}>
                  <FontAwesomeIcon className="header_icon" icon={faUser} />
                  <span className="icon_label">Login / Signup</span>
                </div>
              </div>
            </Navbar>

            <div className="mobile_header_search_holder">
                <Form className="header_search_holder">
                  {/* CATEGORY */}
                  <select className="category_dropdown">
                    <option>All Categories</option>
                  </select>

                  {/* SEARCH */}
                  <div className="search-dropdown-wrapper">
                    <InputGroup className="searchbar_holder">
                      <Form.Control
                        placeholder="Search By Categories"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </InputGroup>

                    {showDropdown && (
                      <Dropdown className="search-dropdown">
                        <Dropdown.Menu show>
                          {productdata?.map((item, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => handleSelectSuggestion(item?.id)}
                            >
                              {item?.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>

                  {/* SEARCH BUTTON */}
                  <button className="search_btn">Search</button>
                </Form>
              </div>
          </div>
        </div>

        {/* old category design  */}
        <Menu_bar_header />
      </section>


      <Profile_Offcanvas
        show={show}
        onHide={() => setShow(false)}
        onHideLogOut={handleLogout}
      />

      <Search_offcanvas />
    </>
  );
}

export default Header;
